import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=12658639&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12658639')) {
      api.createRecord('12658639', component.options)
    } else {
      api.reload('12658639', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=12658639&", function () {
      api.rerender('12658639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Dashboard.vue"
export default component.exports